import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import RetailerLayout from '../components/RetailerLayout';
import PartnerDetailContent from '../components/PartnerDetailContent';
import api from '../lib/api';

const PartnerPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [partner, setPartner] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPartner = async () => {
      setLoading(true);
      try {
        const response = await api.get(`/partners/slug/${slug}`);
        setPartner(response.data);
      } catch (err) {
        try {
          const response = await api.get(`/partners/${slug}`);
          setPartner(response.data);
        } catch {
          setPartner(null);
        }
      } finally {
        setLoading(false);
      }
    };
    if (slug) loadPartner();
  }, [slug]);

  if (loading) {
    return (
      <RetailerLayout>
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4" />
            <p className="text-muted-foreground">Chargement du partenaire...</p>
          </div>
        </div>
      </RetailerLayout>
    );
  }

  if (!partner) {
    return (
      <RetailerLayout>
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-xl font-bold mb-2">Partenaire introuvable</h2>
            <p className="text-muted-foreground mb-4">Le partenaire demandé n'existe pas ou a été désactivé.</p>
            <button onClick={() => navigate(-1)} className="text-blue-600 hover:underline">Retour</button>
          </div>
        </div>
      </RetailerLayout>
    );
  }

  return (
    <RetailerLayout>
      <PartnerDetailContent
        partner={partner}
        slug={slug}
        mode="page"
        onBack={() => navigate(-1)}
      />
    </RetailerLayout>
  );
};

export default PartnerPage;
